import type { FaireProductEntity } from "../../entity_types/product";

export const p_be43e72xaz: FaireProductEntity = {
  token: "p_be43e72xaz",
  type: "product",
  name: "Pinata Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4a4c293d509fe028d0f400c948c70588fce5b4751786eb9b134036cc5e42f77b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e4da473fc1714553813a94b2c23f33fd5fc8faf0daaf71073d0b34f62810fd8.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:08.412Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
